import React from 'react';
import { useUi } from '../../context/UiContext';
import useAnimateOnScroll from '../../hooks/useAnimateOnScroll';
import usePageInteractions from '../../hooks/usePageInteractions';
import Header from './Header';
import Footer from './Footer';
import LoadingScreen from './LoadingScreen';
import CookieConsent from '../ui/CookieConsent';

const MainLayout = ({ children }) => {
    const { isLoading } = useUi();
    
    // Initialize scroll animations and interactions
    useAnimateOnScroll();
    usePageInteractions();

    return (
        <>
            <LoadingScreen isLoading={isLoading} />
            <Header />
            {children}
            <Footer />
            <CookieConsent />
        </>
    );
};

export default MainLayout;